var React = require('react');

function RightArrow2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0, 0)"},React.createElement("path",{"d":"M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z"})));
}

RightArrow2.defaultProps = {"x":"0px","y":"0px","width":"12px","height":"12px","viewBox":"0 0 12 12"};

module.exports = RightArrow2;

RightArrow2.default = RightArrow2;
